export const serverEnum = {
  orderStatus: {
    COMPLETED: "COMPLETED",
    DELIVERING: "DELIVERING"
  }
} 